// Generated by purs version 0.13.8
"use strict";
var Data_Eq = require("../Data.Eq/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Lunarbox_Data_Dataflow_Expression = require("../Lunarbox.Data.Dataflow.Expression/index.js");
var Lunarbox_Data_Dataflow_Runtime = require("../Lunarbox.Data.Dataflow.Runtime/index.js");
var Lunarbox_Data_Dataflow_Scheme = require("../Lunarbox.Data.Dataflow.Scheme/index.js");
var Lunarbox_Data_Dataflow_Type = require("../Lunarbox.Data.Dataflow.Type/index.js");
var Lunarbox_Data_Editor_FunctionData = require("../Lunarbox.Data.Editor.FunctionData/index.js");
var typeBinaryCompare = (function () {
    var v = Lunarbox_Data_Dataflow_Type.createTypeVariable("t0");
    return Lunarbox_Data_Dataflow_Scheme.Forall.create([ v.value0 ])(Lunarbox_Data_Dataflow_Type.typeFunction(v.value1)(Lunarbox_Data_Dataflow_Type.typeFunction(v.value1)(Lunarbox_Data_Dataflow_Type.typeBool)));
})();
var createBinaryCompare = function (name) {
    return function (output) {
        return function (predicate) {
            return {
                name: name,
                expression: Lunarbox_Data_Dataflow_Expression.NativeExpression.create(typeBinaryCompare)(Lunarbox_Data_Dataflow_Runtime.binaryFunction(function ($5) {
                    return (function (v) {
                        return function ($6) {
                            return Lunarbox_Data_Dataflow_Runtime.Bool.create(v($6));
                        };
                    })(predicate($5));
                })),
                functionData: Lunarbox_Data_Editor_FunctionData.internal([ {
                    name: "first value",
                    description: "Any value"
                }, {
                    name: "second value",
                    description: "Any value"
                } ])(output)
            };
        };
    };
};
var equal = createBinaryCompare("are equal")({
    name: "a == b",
    description: "Return true only if both values are equal"
})(Data_Eq.eq(Lunarbox_Data_Dataflow_Runtime.eqRuntimeValue));
var greaterOrEqual = createBinaryCompare("greater or equal")({
    name: "a >= b",
    description: "Compares both values and returns true if the first one is greater or equal than the second"
})(Data_Ord.greaterThanOrEq(Lunarbox_Data_Dataflow_Runtime.ordRuntimeValue));
var greaterThan = createBinaryCompare("greater than")({
    name: "a > b",
    description: "Compares both values and returns true if the first one is greater than the second"
})(Data_Ord.greaterThan(Lunarbox_Data_Dataflow_Runtime.ordRuntimeValue));
var smallerOrEqual = createBinaryCompare("smaller or equal")({
    name: "a <= b",
    description: "Compares both values and returns true if the first one is smaller or equal than the second"
})(Data_Ord.lessThanOrEq(Lunarbox_Data_Dataflow_Runtime.ordRuntimeValue));
var smallerThan = createBinaryCompare("smaller than")({
    name: "a < b",
    description: "Compares both values and returns true if the first one is greater than the second"
})(Data_Ord.lessThan(Lunarbox_Data_Dataflow_Runtime.ordRuntimeValue));
var predicateNodes = [ equal, smallerThan, greaterThan, greaterOrEqual, smallerOrEqual ];
module.exports = {
    predicateNodes: predicateNodes
};
